module.exports = __webpack_public_path__ + "style/img/终端安全管理系统.644a3d32.jpg";